import { motion } from "framer-motion";

/**
 * Kinetic headline — each line is masked (overflow hidden) and slides up
 * on mount with the signature expo-out ease. This is the on-load moment
 * for every Books page hero.
 */
export default function KineticTitle({ lines, className = "", lineClassName = "", delay = 0.05, as: Tag = "h1", testId }) {
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`js-kinetic-line block ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.95, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.13 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

/** Small fade-up for elements that should follow the kinetic title on load.
 * `js-reveal-fade` is a stable hook (see index.css @media print) so review/
 * PDF capture tools can never freeze this content at its hidden initial state. */
export function HeroFade({ children, delay = 0.5, className = "" }) {
  return (
    <motion.div
      className={`js-reveal-fade ${className}`}
      initial={{ opacity: 0, y: 22 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
